module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-11.40924f70.png";